// extracted by css-extract-rspack-plugin
export default {"metricFacet":"aaJF_uEW3d8jS58t","metric":"XjqtYDuYamcUcPhU","topLine":"zhG6haDmInE1w29K","total":"cwFiui37tA3p22dK","label":"dr7aPX22UYga5Pf9"};